const theme = {
  white: '#ffffff',
  primaryBlack: '#1f1645',
  primaryBlue: '#5876b3',
  primaryFont: 'Jost, sans-serif',
  secondaryFont: 'Chelsea Market, cursive',
  sm: '768px',
  md: '1024px',
  lg: '1200px',
  xxlg: '1680px',
};

export default theme;
